import React from 'react';
import styles from './RightBar.module.scss';
import { Collapse } from 'react-bootstrap';
import { ChevronDown } from 'react-bootstrap-icons';

const RightBar = (props) => {
    const { mainPage, details,startCollapse } = props;
    const [showInfo, setShowInfo] = React.useState(startCollapse);
    const handleShowInfo = () => {
        if (showInfo) {
            setShowInfo(false);
        } else {
            setShowInfo(true);
        }
    }
    //console.log(mainPage);
    if (mainPage) {
        return (
            <div className={styles.right_bar}>
                <h3 className={styles.title}>This Issue</h3>
                <div style={{ width: '40%', backgroundColor: '#fff', height: '1px' }}></div>
                <div className={styles.details}>
                    <strong>{details.issue}</strong>
                    <br />
                    ISSN: {details.issn}
                    <br />
                    Volume {details.volume},
                    <br />
                    Number {details.number}
                </div>
                <div style={{ width: '100%', backgroundColor: '#fff', height: '1px', marginLeft: 'auto', marginRight: 'auto' }}></div>
                <ul className={styles.article_list}>
                    {details.articles.map((article, index) => (
                        <li key={index}>
                            <strong><a href={article.url.replace('internal:', '')}>{article.title}</a></strong>
                            <br />
                            {article.author}
                        </li>
                    ))}
                    <li className={styles.more}><a href={details.moreUrl}>See more</a></li>
                </ul>
            </div>
        );
    } else {
        return (
            <div className={styles.right_bar2}>
                <div className={styles.title_container}
                    onClick={handleShowInfo}
                    aria-controls="example-collapse-text"
                    aria-expanded={showInfo}
                >
                    <div className='d-flex justify-content-between'>
                        <h3 className={styles.title}>This Issue</h3>
                        <div className={styles.arrow}
                            style={{ transform: showInfo ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s', width: '20px' }}
                        >
                            <ChevronDown style={{ fontSize: '20px' }} />
                        </div>
                    </div>
                    <div style={{ width: '40%', backgroundColor: '#000', height: '1px' }}></div>

                </div>
                <Collapse in={showInfo}>
                    <div id="example-collapse-text">
                        <div className={styles.details}>
                            <strong>{details.issue}</strong>
                            <br />
                            ISSN: {details.issn}
                            <br />
                            Volume {details.volume},
                            <br />
                            Number {details.number}
                        </div>
                        <div style={{ width: '100%', backgroundColor: '#000', height: '1px', marginLeft: 'auto', marginRight: 'auto' }}></div>
                        <ul className={styles.article_list}>
                            {details.articles.map((article, index) => (
                                <li key={index}>
                                    <strong><a href={article.url.replace('internal:', '')}>{article.title}</a></strong>
                                    <br />
                                    {article.author}
                                </li>
                            ))}
                            <li className={styles.more}><a href={details.moreUrl}>See more</a></li>
                        </ul>
                    </div>
                </Collapse>
            </div>
        );
    }
}

export default RightBar;
